import React, { useState, useCallback, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { UnsubscribePageProps, UnsubscribePageState } from './types';
import { postUnsubscribe } from '../../../services/unsubscribe';
import { getCsrfToken } from '../../../libs/csrfToken';

export const Component: FunctionComponent<UnsubscribePageProps> = ({
  currentUser,
  preferenceEditPath,
  recaptchaSiteKey,
}) => {
  const [state, setState] = useState<UnsubscribePageState>({
    reason: '',
    body: '',
    recaptchaToken: null,
    flash: false,
    flashType: '',
    flashMessage: '',
    isLoading: false
  });

  const handleChangeForm = useCallback(
    (name: string, value: string) => {
      setState((prev) => ({ ...prev, [name]: value }));
    },
    []
  );

  const handleRecaptcha = useCallback(
    (token: string | null) => {
      setState((prev) => ({ ...prev, recaptchaToken: token }));
    },
    []
  );

  const handleFlash = useCallback(
    (flash: boolean, flashType: string, flashMessage: string) => {
      setState((prev) => ({ ...prev, flash, flashType, flashMessage }));
    },
    []
  );

  const handleSubmit = useCallback(async () => {
    let isNavigating = false;
    try {
      setState((prev) => ({ ...prev, flash: false, isLoading: true }));
      const response = await postUnsubscribe(
        { reason: state.reason, body: state.body },
        getCsrfToken()
      );
      if (response.status === 'success') {
        isNavigating = true;
        window.location.href = response.redirectPath;
      } else {
        setState((prev) => ({
          ...prev,
          flash: response.flash,
          flashType: response.flashType,
          flashMessage: response.flashMessage,
        }));
      }
    } catch (error) {
      console.log(error);
      setState((prev) => ({
        ...prev,
        flash: true,
        flashType: 'danger',
        flashMessage: 'エラーが発生しました。再度お試しください。',
      }));
    } finally {
      if (!isNavigating) {
        setState((prev) => ({ ...prev, isLoading: false }));
      }
    }
  }, [state.reason, state.body]);

  return (
    <Presentation
      state={state}
      flash={state.flash}
      flashType={state.flashType}
      flashMessage={state.flashMessage}
      currentUser={currentUser}
      preferenceEditPath={preferenceEditPath}
      onChangeForm={handleChangeForm}
      onSubmit={handleSubmit}
      onRecaptcha={handleRecaptcha}
      recaptchaSiteKey={recaptchaSiteKey}
      handleFlash={handleFlash}
    />
  );
};
